import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  GetCompanyWalletBySubBookingCodeId,
  GetPolicyFileById,
  ReceivedWallet,
} from "../../Service/_index";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
  DeleteIcon,
  SearchIcon,
  CloudOffIcon,
} from "../../Resources/Icons/icons";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import filterr from "../../Resources/Images/filter-lines.png";
import exportt from "../../Resources/Images/export.png";
import { visuallyHidden } from "@mui/utils";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import ButtonGroup from "@mui/material/ButtonGroup";
import Drawer from "@mui/material/Drawer";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import { CSVLink } from "react-csv";
import { GetPolicyFindbyId } from "../../Service/_index";
import ReceivedTransaction from "./ReceivedTransaction";
import Loader from "../../UiComponents/Loader/Loader";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import { Divider, Modal } from "@mui/material";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
// import { FormattedDate } from "rsuite";
import wallett from "../../Resources/Images/wallet.png";
import user from "../../Resources/Images/user.png";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getClassName = (data) => {
  console.log("data", data);
  return data.policyNumber ? "file_link" : null;
};

const headCells = [
  {
    id: "approvedDate",
    numeric: true,
    disablePadding: false,
    label: "Approve Date",
  },
  {
    id: "policyDate",
    numeric: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    numeric: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    numeric: true,
    disablePadding: false,
    label: "Policy Number",
    class: getClassName,
    onClick: true,
  },
  {
    id: "customerName",
    numeric: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "paymentMode",
    numeric: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  {
    id: "netPremium",
    numeric: true,
    disablePadding: false,
    label: "Net Premium",
  },
  {
    id: "totalPremium",
    numeric: true,
    disablePadding: false,
    label: "Total Premium",
  },
  {
    id: "commisionRecievable",
    numeric: true,
    disablePadding: false,
    label: "Commision Payable",
  },
  {
    id: "policyBalance",
    numeric: true,
    disablePadding: false,
    label: "Policy Balance",
  },
  {
    id: "walletBalance",
    numeric: true,
    disablePadding: false,
    label: "Wallet Balance",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.numeric ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const ManageWallet = (props) => {
  const {
    selectedData,
    formType,
    setOpenDrawer,
    GetData,
    startDate,
    endDate,
    calculateSum,
    totalWallet,
  } = props;
  let formRef = useRef();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [data, setData] = useState([]);
  const [openPaidTransaction, setOpenPaidTransaction] = useState();
  const [functionType, setFunctionType] = useState();
  const [openLoader, setOpenLoader] = useState(false);
  const [originalData, setOriginalData] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
  });
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(data), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, data]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;
  const UserId = sessionStorage.getItem("UserId");

  const GetUserWalletDetails = () => {
    setOpenLoader(true);
    GetCompanyWalletBySubBookingCodeId(selectedData?.[0]?._id, {
      startDate,
      endDate,
    }).then((res) => {
      setData(res?.data);
      setOriginalData(res?.data);
      setOpenLoader(false);
    });
  };

  useEffect(() => {
    GetUserWalletDetails();
  }, []);

  const PaidUserName = visibleRows?.[0]?.userName;

  const ReceivedFunction = () => {
    setOpenPaidTransaction(true);
    setFunctionType("Received");
  };

  const onSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm === "") {
      setData(originalData);
    } else {
      const filteredData = originalData.filter((item) => {
        return Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(searchTerm)
        );
      });
      setData(filteredData);
    }
    setPage(0);
  };

  const header = [
    { label: "Policy Date", key: "approvedDate" },
    { label: "Company Name", key: "companyName" },
    { label: "Policy Number", key: "policyNumber" },
    { label: "Customer Name", key: "customerName" },
    { label: "Payment Mode", key: "paymentMode" },
    { label: "Net Premium", key: "netPremium" },
    { label: "Total Premium", key: "totalPremium" },
    { label: "Commission Payable", key: "commisionRecievable" },
    { label: "Policy Balance", key: "policyBalance" },
    { label: "Wallet Balance", key: "result" },
  ];
  const csvFile = {
    filename: "Company Management Wallet ",
    headers: header,
    data: data,
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?.policyId)
      .then((res) => {
        const pdfUrl = res?.policyFile.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
        );
      })
      .catch((err) => {
        ToastError("Something went wrong");
        setOpenLoader(false);
      });
  };

  const formattedData = data?.map((item) => ({
    ...item,
    approvedDate: dayjs(item?.approvedDate).format("DD/MM/YYYY hh:mm A"),
    policyDate: dayjs(item?.policyDate).format("DD/MM/YYYY"),
  }));

  const handleSubmit = (e) => {
    e.isCommisionRecievable = true;
    const RandomNumber = Math.floor(Math.random() * 9000000000) + 1000000000;
    e.userId = selectedData.userId;
    e.policyNumber = RandomNumber.toString();
    e.status = "WALLET";
    e.withTDS = false;
    e.bookingCodeId = selectedData?.bookingCodeId;
    e.subBookingCodeId = selectedData?.subBookingCodeId;
    // e.paymentMode = functionType === "Paid" ? "PAID" : "RECEIVED"
    e.createdBy = UserId;
    ReceivedWallet(e)
      .then((res) => {
        console.log(res);
        GetData();
        GetUserWalletDetails();
        setOpenPaidTransaction(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div style={{ padding: 15 }}>
        <Grid
          container
          mt={7}
          paddingRight={2}
          sx={{ justifyContent: "flex-end" }}
        >
          {/* <CloseIcon
            onClick={() => setOpenDrawer(false)}
            sx={{ cursor: "pointer" }}
          /> */}
        </Grid>
        <div className="container-fluid">
          <div>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems="center"
                className="Master_Card_Sub_Container"
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{ display: "flex", gap: "7px" }}
                >
                  <Typography className="Master_Card_Tittle">
                    Manage Wallet
                  </Typography>
                  <img src={user} width="22px" height="22px" />
                  <Typography sx={{ color: "#667085" }}>
                    {selectedData?.[0]?.bookingCode}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  className="d-flex justify-content-end"
                  gap={"8px"}
                >
                  <Button
                    className="export_button"
                    fullWidth
                    startIcon={
                      <CloudDownloadOutlinedIcon
                        sx={{
                          color: "#344054",
                        }}
                      />
                    }
                  >
                    <CSVLink style={{ textDecoration: "none" }} {...csvFile}>
                      <p className="button-text">Export</p>
                    </CSVLink>
                  </Button>

                  <Button
                    className="Master_Card_create_Button w-100"
                    onClick={ReceivedFunction}
                  >
                    Received
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Grid
                  item
                  marginLeft={2}
                  margin={1}
                  sx={{
                    backgroundColor: "#F0F5FA",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    padding: "2px",
                    paddingRight: "15px",
                    paddingLeft: "15px",
                    gap: "10px",
                    border: "1px solid #DFE7F1",
                  }}
                >
                  <Grid>
                    <img src={wallett} width="18px" height="17px" />
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#1E3A5F",
                        fontSize: 16,
                        lineHeight: "1.2",
                      }}
                    >
                      ₹ {data?.[0]?.walletBalance || 0}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "500",
                        color: "#667085",
                        fontSize: 12,
                        lineHeight: "1.2",
                      }}
                    >
                      Total Manage Wallet
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={3.1} margin={1}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    onChange={(e) => {
                      onSearch(e);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search in Manage Wallet"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={formattedData}
                columns={headCells}
                handleOnClickBehaviour={OpenPolicyFile}
              />
            </Grid>
          </div>
        </div>
      </div>
      <Modal
        open={openPaidTransaction}
        onClose={() => setOpenPaidTransaction(false)}
        aria-labelledby="paid-transaction-modal"
        aria-describedby="paid-transaction-details"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", sm: 600, md: "30%" },
            height: "auto",
            maxHeight: "80vh",
            bgcolor: "background.paper",
          }}
        >
          {openPaidTransaction ? (
            <ReceivedTransaction
              setOpenPaidTransaction={setOpenPaidTransaction}
              selectedData={selectedData}
              PaidUserName={PaidUserName}
              GetUserWalletDetails={GetUserWalletDetails}
              functionType={functionType}
              GetData={GetData}
              onSubmit={handleSubmit}
              formRef={formRef}
            />
          ) : null}
          <Box
            display="flex"
            justifyContent="flex-end"
            mt={4}
            sx={{
              backgroundColor: "#F1F4F7",
              borderTopColor: "#EAECF0",
              padding: "16px",
            }}
          >
            <Button
              onClick={() => setOpenPaidTransaction(false)}
              style={{
                marginRight: "10px",
                textTransform: "none",
                color: "#000",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => formRef.current?.submitForm()}
              style={{
                textTransform: "none",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
      <Loader open={openLoader} />
    </>
  );
};

export default ManageWallet;
